import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const ericssonNETargetInfoTemplateOVMOWLAN: FormTemplate = {
  version: '1.0.1',
  name: 'Ericsson NE Target Info',
  key: 'ERICSSON_NE_TARGET_INFO',
  general: {
    metadata: {
      layout: {
        rows: [
          [
            'targetDeliveryTemplate',
          ],

        ],
      },
    },
    fields: {
      targetDeliveryTemplate: {
        type: 'select',
        label: 'Target Delivery Template',
        hide: 'true',
        initial: '',
        options: [
          {
            label: 'Select a template',
            value: '',
          }
        ],
        optionsFirstTranslatable: true,
      },
    },
  },
  EIMSTARGET: {
    metadata: {
      layout: {
        rows: [
          [
            'TID',
            'AFID',
          ],
          [
            'NETOPID',
            'SUBNETOPID',
          ],
          [
            'LEAID',
            'WARRANTID',
          ],
          [
            'LEMFID',
            'USEONELEMF',
          ],
        ],
      },
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      NETOPID: {
        label: 'Network Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 20,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      SUBNETOPID: {
        label: 'Subnetwork Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 20,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      LEAID: {
        label: 'LEA ID',
        type: 'text',
        initial: 'XCIPIO',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      WARRANTID: {
        label: 'Warrant ID',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      LEMFID: {
        label: 'LEMF ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      USEONELEMF: {
        label: 'Use one LEMF',
        type: 'checkbox',
        initial: false,
      },
    },
  },
  EIMSMC: {
    metadata: {
      layout: {
        rows: [
          [
            'IRI_MCID',
            'IRI_SUPPNEID',
          ],
          [
            'CC_MCID',
            'CC_SUPPNEID',
          ]
        ],
      },
    },
    fields: {
      IRI_MCID: {
        label: 'IRI MC ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
      IRI_SUPPNEID: {
        label: 'IRI MC SuppNeID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
      CC_MCID: {
        label: 'CC MC ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
      CC_SUPPNEID: {
        label: 'IRI MC SuppNeID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
    },
  }
};
